import React from "react";

const playBounce = (event, state) => {
  const el = event.currentTarget;
  el.classList.remove("map-hover-enter", "map-hover-leave");
  void el.offsetWidth;
  el.classList.add(state);
};

const bounceHandlers = {
  onMouseEnter: (e) => playBounce(e, "map-hover-enter"),
  onMouseLeave: (e) => playBounce(e, "map-hover-leave"),
};

const caregiverLayers = [
  {
    id: "toc1",
    src: "/assets/svgs/type-care-svgs/toc1.svg",
    alt: "Paid and unpaid caregiver details",
    style: { left: "34%", top: "56%" },
  },
  {
    id: "toc2",
    src: "/assets/svgs/type-care-svgs/toc2.svg",
    alt: "Types of caregivers overview",
    style: { left: "60%", top: "32%" },
  },
];

const TypesOfCaregiversModel = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const getScrollTarget = (layerId) => {
    const scrollMap = {
      toc1: "defining-family-caregiving",
      toc2: "table-note-terminology",
    };
    return scrollMap[layerId];
  };

  return (
    <main className="relative pt-5">
      <section className="p-2">
        <div className="relative mx-auto aspect-[1070/750] max-w-[1100px]">
          {caregiverLayers.map((layer) => {
            const hoverTiming = {
              "--map-seq-name": "mapSeqReveal",
              "--map-seq-duration": "1200ms",
              "--map-seq-delay": "0ms",
            };

            const scrollTarget = getScrollTarget(layer.id);
            const handleClick = scrollTarget
              ? () => scrollToSection(scrollTarget)
              : undefined;

            return (
              <div
                key={layer.id}
                className="absolute -translate-x-1/2 -translate-y-1/2 group"
                style={layer.style}
              >
                <div className="relative">
                  <img
                    src={layer.src}
                    alt={layer.alt}
                    loading="lazy"
                    className="select-none object-contain max-w-max map-hover-bounce hover:cursor-pointer pointer-events-auto map-seq"
                    style={{ ...hoverTiming }}
                    {...bounceHandlers}
                    {...(handleClick ? { onClick: handleClick } : {})}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default TypesOfCaregiversModel;
